import {Modal} from 'antd';
import {useEffect} from 'react';

import {Locale} from '../../../provider/locale/locale';
import {useModal} from '../../../provider/modal/modal-hook';
import {postCompanySelectorCompanySchema} from '../../../service/feature-companies/feature-companies-api-type';
import {CompaniesSelectorFeatureEnum} from '../../../service/feature-companies/feature-companies-const';
import {useCompaniesSelector} from '../../../service/feature-companies/feature-companies-hook';
import {PostSelectorCompanyType} from '../../../service/feature-companies/feature-companies-type';
import {useCreatePromotion} from '../../../service/promotions/promotions-hook';
import {CommonPromotionStatusEnum, PromotionFormType} from '../../../service/promotions/promotions-type';

import {PromotionForm} from './promotion-form';
import {preparePromotionRequestData, PROMOTION_FORM_MODAL_WIDTH} from './promotion-form-helper';

type PropsType = {
    setIsOpen: (isOpen: boolean) => void;
    onCreateSuccess?: VoidFunction;
};

export function CreatePromotionFormModal({setIsOpen, onCreateSuccess}: PropsType): JSX.Element {
    const companiesSelector = useCompaniesSelector<PostSelectorCompanyType>({
        feature: CompaniesSelectorFeatureEnum.Posts,
        companySchema: postCompanySelectorCompanySchema,
        resourceId: null,
    });

    const {modal} = useModal();
    const {mutateAsync: createPromotion} = useCreatePromotion();
    const {initializeSelector, selectorId} = companiesSelector;

    useEffect(() => {
        initializeSelector();
    }, [initializeSelector]);

    async function handleSubmit(values: PromotionFormType, status: CommonPromotionStatusEnum): Promise<void> {
        await createPromotion(preparePromotionRequestData(values, selectorId, status));
        onCreateSuccess?.();
    }

    function handleCancel(): void {
        modal.confirm({
            maskClosable: true,
            title: <Locale stringKey="PROMOTIONS__CREATE__CONFIRM_CLOSE__TITLE" />,
            content: <Locale stringKey="PROMOTIONS__CONFIRM_CLOSE__CONTENT" />,
            okText: <Locale stringKey="PROMOTIONS__CREATE__CONFIRM_CLOSE__CONFIRM" />,
            cancelText: <Locale stringKey="POPUP__BUTTON__CANCEL" />,
            okButtonProps: {danger: true, type: 'primary'},
            onOk: () => setIsOpen(false),
        });
    }

    return (
        <Modal
            centered
            destroyOnClose
            footer={null}
            onCancel={handleCancel}
            open
            title={<Locale stringKey="PROMOTIONS__CREATE__TITLE" />}
            width={PROMOTION_FORM_MODAL_WIDTH}
        >
            <PromotionForm
                closeModal={() => setIsOpen(false)}
                companiesSelector={companiesSelector}
                mode="create"
                onCancel={handleCancel}
                onSubmit={handleSubmit}
            />
        </Modal>
    );
}
